import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme, modal }) => ({
  minHeight: modal ? 'unset' : '100vh',
  display: 'flex',
  backgroundColor: '#DEEFFB',
  backgroundImage: 'url(/assets/svg/circles.svg)',
  backgroundSize: 'contain',
  backgroundPosition: 'left',
  backgroundRepeat: 'no-repeat',
  overflow: 'auto',
  paddingBottom: modal ? 0 : 32,
  '& .logo': {
    marginBottom: 20,
  },
  '& .form-container': {
    // 'width': 480,
    // 'height': 'fit-content',
    [theme.breakpoints.down('md')]: {},
    '& > .MuiPaper-elevation': {
      boxShadow:
        '0px 5px 20px 0px rgba(163, 207, 237, 0.10), 0px 80px 110px -40px rgba(163, 207, 237, 0.47)',
    },
  },
}));

export const ReviewContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  flex: 1,
  color: theme.palette.primary.contrastText,
  paddingTop: 96,
  '& .embedsocial-reviews': {
    width: '100%',
    maxWidth: 750,
    marginLeft: 'auto',
  },
  '& .cta': {
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.contrastText,
  },
}));

export const LoginForm = styled(Card)(({ theme, modal }) => ({
  padding: theme.spacing(modal ? 0 : 7.5),
  [theme.breakpoints.up('md')]: {
    width: '100%',
  },
  '& .logo': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    margin: 'auto',
    width: 80,
    height: 80,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  '& .fields': {
    margin: 'auto',
  },
}));
